import SkeletonCard from "../UI/SkeletonCard/SkeletonCard"

const ArticleLoader = () => {
  return ( 
    <div className="w-full lg:px-10 flex flex-col">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  )
}

export default ArticleLoader;